import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { createContext, useReducer, useEffect } from "react";
import { insert } from "../utils/pageactions";
export const CCPValue = createContext(null);
export const CCPDisbatch = createContext(null);
const reducer = (state, action) => {
  const newState = { ...state };
  if (action.type === "set") {
    return action.value;
  }
  if (action.type === "copy") {
    const _item = JSON.parse(JSON.stringify(action.item));
    return _item;
  }
  if (action.type === "paste") {
    action.dispatch({
      type: "insert",
      block: newState,
      path: action.path,
    });
    return newState;
  }

  return newState;
};

export default function CCPContext({ children }) {
  const [state, dispatch] = useReducer(reducer, null);
  const { appId, pageId } = useParams();

  useEffect(() => {
    if (appId && pageId) {
    }
  }, [appId, pageId]);

  return (
    <CCPValue.Provider value={state}>
      <CCPDisbatch.Provider value={dispatch}>{children}</CCPDisbatch.Provider>
    </CCPValue.Provider>
  );
}
